function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.328 23.53c.058-.234.318-.487.779-.759.46-.272.95-.516 1.466-.733a9.643 9.643 0 001.476-.771c.468-.297.733-.577.798-.837.046-.182.047-.379.002-.59-.043-.21-2.081-6.767-2.168-6.912-.196-.327-1.238-.457-1.817-.308-4.675 1.2-5.763 4.111-5.997 5.323-.217 1.137-1.63 6.509 2.784 13.568 4.616 7.381 10.796 9.497 11.123 9.579 1.194.297 5.015.555 7.509-2.8.357-.48.801-1.375.582-1.751-.081-.14-4.946-4.896-5.112-5.034a1.314 1.314 0 00-.52-.274c-.261-.065-.631.04-1.115.312-.482.274-2.124 1.645-2.58 1.926-.456.28-.8.39-1.035.331a1.347 1.347 0 01-.413-.206c-.135-.091-2.667-2.389-4.036-4.536-1.37-2.147-1.832-5.012-1.726-5.528z",
  "data-svg-class": "Icon",
  stroke: "#0060A9",
  strokeLinecap: "square",
  fill: "none",
  fillRule: "evenodd"
});

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.44fa0337.svg";
export { ForwardRef as ReactComponent };